/*
:Page: Travel Policy Details
*/
import CryptoJS from "crypto-js";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import NonMotorPolicyDetailsSkeleton from "../../components/common/Loader/NonMotorPolicyDetailsSkeleton";
import BackdropModal from "../../components/common/modal/backdropModal";
import DownloadBtn from "../../components/common/downloadBtn/downloadBtn";
import MobileFooter from "../../components/common/sideNavbar/mobileFooter";
import Tabs from "../../components/common/tabs/tabs";
import AnimatedTabContent from "../../components/common/animatedTabContent/animatedTabContent";
import NonMotorPolicyCard from "../../components/nonMotorPolicyCard/nonMotorPolicyCard";
import useLanguageTranslate from "../../hooks/useLanguageTranslate";
import useScreenResolution from "../../hooks/useScreenResolution";
import { policyView } from "../../redux/features/motor/getQuoteSlice";
import { clearNewMotorFormData } from "../../redux/features/newMotorFormSlice";
import { getPolicyViewResponse } from "../../redux/features/policyDetailsSlice";
import { decodeQueryString } from "../../utils";
import { getClientSource } from "../../utils/getClientSource";
import Breadcrumb from "../lifeInsurancePages/PolicyOverview/Breadcrumb";
import {
  policyOverview,
  vehicleCertificate,
} from "../motorInsurancePages/policyOverview/motorPolicyDataFile";
import ManagePolicyTab from "../motorInsurancePages/policyOverview/tabViews/managePolicyTab";
import PolicyOverviewTab from "../motorInsurancePages/policyOverview/tabViews/policyOverviewTab";
import { getFilteredTravelCards } from "./travelPolicyDataFile";

const TravelPolicyDetailsPage = () => {
  // posthog show hide feature flags
  // const AddCoversEnabled = useFeatureFlagEnabled("Add_Covers");
  // const ChangePlanEnabled = useFeatureFlagEnabled("Change_plan");
  // const CancelPolicyEnabled = useFeatureFlagEnabled("Cancel_policy");
  // const ChangePlateEnabled = useFeatureFlagEnabled("change_plate_number");
  // const AdjustCarValueEnabled = useFeatureFlagEnabled("adjust_car_value");
  // const TransferPolicyEnabled = useFeatureFlagEnabled("transfer_policy");
  // const RemoveBankEnabled = useFeatureFlagEnabled("remove_bank");
  const location = useLocation();
  const translate = useLanguageTranslate();
  const policyNumber = location.state?.data?.PolicyNumber;
  const GetPolicyDetails = location.state?.data;
  const { i18n } = useTranslation();
  const { policy_id } = useParams();
  const AdjustCarValueEnabled =
    GetPolicyDetails?.PlanName == "TPL" ? false : true;
  const RemoveBankEnabled =
    GetPolicyDetails?.IsMortgaged == true && GetPolicyDetails?.LenderCode != ""
      ? true
      : false;

  const policyViewResponseDetails = useSelector(getPolicyViewResponse);
  const policyStatusCode = policyViewResponseDetails?.PolicyHeader?.StatusCode;
  const isPolicyActive = policyStatusCode == "05" ? true : false;
  const AddCoversEnabled = true;
  const ChangePlanEnabled = true;

  const secretKey = "i-hate-meej";

  // Revert to Base64 format using split and join
  const base64EncryptedValue = (policy_id || "")
    .split("-")
    .join("+") // Replace '-' with '+'
    .split("_")
    .join("/"); // Replace '_' with '/'

  // Decrypt the value
  let originalValue = "";
  try {
    if (base64EncryptedValue) {
      const bytes = CryptoJS.AES.decrypt(base64EncryptedValue, secretKey);
      originalValue = bytes.toString(CryptoJS.enc.Utf8);
    }
  } catch (e) { originalValue = ""; }
  console.log(originalValue);
  const [searchParams] = useSearchParams();

  const [PolicyNumber, setPolicyNumber] = useState(originalValue);
  const [Channel, setChannel] = useState(getClientSource());
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const policyDetails = useSelector(
    (state) => state.policyDetails.PolicyDetails,
  );
  const policyDetailsStatus = useSelector(
    (state) => state.policyDetails.status,
  );
  const policyDetailsError = useSelector((state) => state.policyDetails.error);
  const [breadCrumbData, setBreadCrumbData] = useState(null);

  const polReq = {
    PolicyNumber,
    Channel,
  };

  // const PolicyViewReq = {
  //   PolicyNumber: "P/003/14/20/8003/0020575-02",
  //   Channel: "online.solidarity"
  // }
  //const PolicyViewresDetails = useSelector(PolicyViewResponse);

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "PolicyOverview",
  );
  const [downloadMenuClicked, setDownloadMenuClicked] = useState(false);
  const [policyLabel, setPolicyLabel] = useState("");
  const screenResolution = useScreenResolution();
  const toggleDownloadMenuClicked = () => {
    setDownloadMenuClicked(!downloadMenuClicked);
  };

  const handleTabClick = (tabType) => {
    setActiveTab(tabType);

    const Path = `${location.pathname}${location.search}`;

    if (location.state?.activeTab) {
      const { activeTab, ...restState } = location.state;
      navigate(Path, { state: { ...restState, activeTab: "" } });
    }
  };

  useEffect(() => {
    setBreadCrumbData([
      {
        label: translate("My Policy", "وثيقتي"),
        link: "/my-policy",
        clickable: true,
        name: "my_policy",
      },
      {
        label: translate("Travel Policy", "وثيقة تأمين السفر"),
        clickable: false,
        name: "current_plan",
        isActive: true,
      },
    ]);
  }, [i18n.resolvedLanguage]);

  useEffect(() => {
    if (policyDetails == null) {
      dispatch(policyView(polReq));
    } else if (policyDetails?.PolicyHeader?.PolicyNumber != policyNumber) {
      dispatch(policyView(polReq));
    }

    dispatch(clearNewMotorFormData());

    console.log(policyDetails);
    console.log("Testing: " + policyDetailsStatus);
  }, [dispatch]);

  useEffect(() => {
    if (policyDetailsStatus == "succeeded") {
      console.log("Policy Make: ", policyDetails);
    }
  }, [policyDetails, policyDetailsStatus]);
  const Info = {
    PolicyNumber: originalValue,
    status: "",
    Make: "",
    Model: "",
    PlanName: "",
    StartDate: "",
    EndDate: "",
    RegNo: "",
  };

  const filteredTravelCards = useMemo(
    () => getFilteredTravelCards(policyDetails?.PolicyHeader),
    [policyDetails?.PolicyHeader],
  );

  // Travel Policy details tabs
  const tabs = useMemo(
    () => [
      {
        label_en: "Policy Overview",
        label_ar: "نظرة عامة على السياسة",
        type: "PolicyOverview",
      },
    ],
    [],
  );

  vehicleCertificate.tableData = [];
  vehicleCertificate.tableData = [
    {
      id: 1,
      column1: "Owner",
      column1_ar: "مالك",
      column2:
        policyDetails?.PolicyHeader?.Party?.FirstName +
        " " +
        policyDetails?.PolicyHeader?.Party?.LastName, // Correctly assigning the variable without curly braces
      btn: { btn_lable_en: "Transfer", btn_lable_ar: "تحويل" },
    },
    {
      id: 2,
      column1: "Policy Number",
      column1_ar: "رقم الوثيقة",
      column2: policyDetails?.PolicyHeader.PolicyNumber,
    },
    {
      id: 3,
      column1: "Start Date",
      column1_ar: "تاريخ البدء",
      column2: policyDetails?.PolicyHeader.FromDateStr,
    },
    {
      id: 4,
      column1: "End Date",
      column1_ar: "تاريخ النهاية",
      column2: policyDetails?.PolicyHeader.ToDateStr,
    },
    {
      id: 5,
      column1: "Departure date",
      column1_ar: "تاريخ المغادرة",
      column2: policyDetails?.PolicyHeader.DepartureDate,
    },
    {
      id: 6,
      column1: "Return date",
      column1_ar: "تاريخ العودة",
      column2: policyDetails?.PolicyHeader.ReturnDate,
    },
    {
      id: 7,
      column1: "Plan Type",
      column1_ar: "نوع الخطة",
      column2: policyDetails?.PolicyHeader.PlanType,
    },
    {
      id: 8,
      column1: "Plan Name",
      column1_ar: "اسم الخطة",
      column2: policyDetails?.PolicyHeader.PlanName,
    },
    {
      id: 9,
      column1: "Number of Passengers",
      column1_ar: "عدد المسافرين",
      column2: policyDetails?.PolicyHeader.NumberOfPassengers || "1",
    },
    {
      id: 10,
      column1: "Coverage Area",
      column1_ar: "منطقة التغطية",
      column2: policyDetails?.PolicyHeader.CoverageArea || "Worldwide",
    },
  ];

  // Show hide conditions for Manage Policy cards
  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "PolicyOverview":
        return (
          <PolicyOverviewTab
            handleDownloadMenuClicked={toggleDownloadMenuClicked}
            showDownloadPopup={downloadMenuClicked}
            doc={policyDetails?.Reports}
            status={policyDetailsStatus}
            policyDetails={policyDetails}
          />
        );
      case "ManagePolicy":
        if (!isPolicyActive) return null;
         if (filteredTravelCards.length === 0) {
          return (
            <div className="p-6 text-center text-[#5B6871]">
              {translate(
                "Endorsement options are not available after the policy inception date.",
                "خيارات التعديل غير متاحة بعد تاريخ بدء الوثيقة.",
              )}
            </div>
          );
        }
        return (
          <ManagePolicyTab
            cards={filteredTravelCards}
            policyDetails={policyDetails?.PolicyHeader}
          />
        );

      default:
        return null;
    }
  };

  const params = decodeQueryString();

  useEffect(() => {
    if (params.tabType) {
      setActiveTab(params.tabType);
    }
  }, [params?.tabType]);

  // Show skeleton while policy data is being fetched (lazy-load)
  if (policyDetailsStatus === "loading" || !policyDetails?.PolicyHeader) {
    return <NonMotorPolicyDetailsSkeleton partialData={location.state?.data} />;
  }

  // Show error state if policy fetch failed
  if (policyDetailsStatus === "failed") {
    return (
      <div className="p-6 max767:p-0">
        <div className="flex justify-center items-center min-h-screen">
          <div className="text-center">
            <p className="text-red-500 text-lg mb-4">
              {translate(
                "Failed to load policy details",
                "فشل في تحميل تفاصيل الوثيقة",
              )}
            </p>
            <button
              onClick={() => dispatch(policyView(polReq))}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              {translate("Retry", "إعادة المحاولة")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max767:p-0">
      <div className="flex justify-between items-center">
        {!screenResolution.mobile && <Breadcrumb items={breadCrumbData} />}
        {/* {!screenResolution.mobile && (
          <span className="hidden last-login text-right text-xs not-italic font-normal leading-4 text-gray-700">
            Last Login: 03 November 2024 at 05:20{" "}
          </span>
        )} */}
      </div>
      <NonMotorPolicyCard
        getPolicyDetails={Info}
        content={policyOverview?.policyInfo}
        handleDownloadMenuClicked={toggleDownloadMenuClicked}
        car={policyDetails?.PolicyHeader}
        isRenewable={false}
      />
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={handleTabClick}
        className="max767:!justify-start rtl:max767:pr-[5%]"
      />
      <AnimatedTabContent activeTab={activeTab} order={tabs.map((t) => t.type)}>
        {renderActiveTabContent()}
      </AnimatedTabContent>
      {screenResolution.mobile && <MobileFooter />}
      <div className="downloaddocumentsmodal">
          <BackdropModal
            show={downloadMenuClicked}
            onClose={toggleDownloadMenuClicked}
            title={translate("Download Documents", "تحميل المستندات")}
          >
            <div className="flex-row">
              <DownloadBtn
                filesData={(Array.isArray(policyDetails?.Reports) ? policyDetails.Reports : []).map((d) => ({
                  fileName: d.ID,
                  fileName_ar: d.ID,
                  filesData: { url: d.File, size: "165.7 KB" },
                }))}
                className={"mb-2"}
              />
            </div>
          </BackdropModal>
        </div>
      </div>
  );
};

export default TravelPolicyDetailsPage;
